import {ROUTE} from '@/constants/main/route';
import globalDomains from '@/utils/global-domains';
import basic from '@/components/channel/pc/layout/Setting/basic';
import {ChannelT} from '@/utils/i18n/channel';

export interface MenuItem {
  activeKey?: string;
  type: string;
  link: string;
  name: string;
  managerEnter: boolean;
}

export interface MenuItemList {
  channelSetting: MenuItem[];
  userAuthSetting: MenuItem[];
  activeHistory: MenuItem[];
  advertiseSetting: MenuItem[];
}

export const MENU_LINK: MenuItemList = {
  channelSetting: [
    {
      activeKey: 'basic',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.BASIC,
      name: ChannelT('기본 설정'),
      managerEnter: false,
    },
    {
      activeKey: 'home',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.HOME_SECTION,
      name: ChannelT('홈 섹션'),
      managerEnter: false,
    },
    {
      activeKey: 'board',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.POST,
      name: ChannelT('게시판'),
      managerEnter: false,
    },
    {
      activeKey: 'sooptore',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.SOOP_STORE,
      name: ChannelT('숲토어 영역'),
      managerEnter: false,
    },
    {
      activeKey: 'banWord',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.BAN_KEYWORD,
      name: ChannelT('금칙어'),
      managerEnter: true,
    },
  ],
  userAuthSetting: [
    {
      activeKey: 'manager',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.CHANNEL_MANAGER,
      name: ChannelT('매니저'),
      managerEnter: false,
    },
    {
      activeKey: 'fan',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.FAN_CLUB,
      name: ChannelT('팬 관리'),
      managerEnter: false,
    },
    {
      activeKey: 'vodAuth',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.VOD_AUTH,
      name: ChannelT('VOD 권한'),
      managerEnter: false,
    },
    {
      activeKey: 'blacklist',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.BLACK_LIST,
      name: ChannelT('블랙리스트'),
      managerEnter: true,
    },
    {
      activeKey: 'vodBlacklist',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.CLIP_BLACKLIST,
      name: ChannelT('클립 / Catch 블랙리스트'),
      managerEnter: false,
    },
  ],
  activeHistory: [
    {
      type: 'internal',
      link: globalDomains.MYREVENUE_AFREECATV,
      name: ChannelT('내 수익'),
      managerEnter: false,
    },
    {
      type: 'internal',
      link: `${globalDomains.POINT_AFREECATV}/Balloon/AfreecaNormalExchange.asp?gifttype=1`,
      name: ChannelT('선물 받은 별풍선'),
      managerEnter: false,
    },
    {
      activeKey: 'searchInfo',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.SEARCH_INFO,
      name: ChannelT('검색 정보 관리'),
      managerEnter: false,
    },
    {
      activeKey: 'badge',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.MEDAL,
      name: ChannelT('메달 / 배지 관리'),
      managerEnter: false,
    },
  ],
  advertiseSetting: [
    {
      activeKey: 'midroll',
      type: 'route',
      link: ROUTE.CHANNEL.SETTING.MIDROLL,
      name: ChannelT('중간광고 설정'),
      managerEnter: false,
    },
  ],
};

export const ACTIVE_MENU_GROUP = [
  {basic: [ROUTE.CHANNEL.SETTING.BASIC, ROUTE.CHANNEL.SETTING.TITLE_IMAGE]},
  {home: [ROUTE.CHANNEL.SETTING.HOME_SECTION]},
  {board: [ROUTE.CHANNEL.SETTING.POST]},
  {sooptore: [ROUTE.CHANNEL.SETTING.SOOP_STORE]},
  {banWord: [ROUTE.CHANNEL.SETTING.BAN_KEYWORD]},
  {
    manager: [
      ROUTE.CHANNEL.SETTING.CHATTING_MANAGER,
      ROUTE.CHANNEL.SETTING.CHANNEL_MANAGER,
    ],
  },
  {
    fan: [
      ROUTE.CHANNEL.SETTING.FAN_CLUB,
      ROUTE.CHANNEL.SETTING.SUBSCRIBE,
      ROUTE.CHANNEL.SETTING.SUPPORTER,
    ],
  },
  {
    vodAuth: [
      ROUTE.CHANNEL.SETTING.VOD_AUTH,
      ROUTE.CHANNEL.SETTING.VOD_DOWNLOAD_REJECT,
      ROUTE.CHANNEL.SETTING.VOD_EDITOR,
    ],
  },
  {
    blacklist: [ROUTE.CHANNEL.SETTING.BLACK_LIST],
  },
  {
    vodBlacklist: [ROUTE.CHANNEL.SETTING.CLIP_BLACKLIST],
  },

  {
    searchInfo: [ROUTE.CHANNEL.SETTING.SEARCH_INFO],
  },
  {badge: [ROUTE.CHANNEL.SETTING.MEDAL, ROUTE.CHANNEL.SETTING.BADGE]},
  {midroll: [ROUTE.CHANNEL.SETTING.MIDROLL]},
];
